module.exports = __webpack_public_path__ + "img/branch-particle-04.216775ab.png";